<template>
  <file-upload type="single" v-model="single" />
</template>
<script>
import { FileUpload } from "../";
export default {
  name: "file-upload-test",
  components: {
    // Macro,
    // MegaMenuWebComponent,
    FileUpload,
  },
  data() {
    return {
      single: ""
    }
  }
};
</script>